import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import {
  Card,
  Flex,
  Statistic,
  TextComponent,
} from '@monorepo/react-components';
import { useResponsiveness } from '@monorepo/react-hooks';
import { Account, Application } from '@monorepo/types';
import DashboardTooltip from '../../dashboard-common/dashboard-tooltip/dashboard-tooltip';

import './progress-cards.scss';

interface Props {
  profit: number;
  credits: number;
  account: Account;
  application: Application;
}

const ProfitWithdrawal: FunctionComponent<Props> = ({
  profit,
  credits,
  application,
}) => {
  const { isMobile } = useResponsiveness();
  const { t } = useTranslation(['dashboardTemplates', 'common']);

  const tooltipText = {
    [Application.TTP]: t('dashboardTemplates:balance_invalid_profits'),
    [Application.THE5ERS]: t(
      'dashboardTemplates:pnl_credits_considered_for_withdrawal',
    ),
  };

  return (
    <Card
      hoverable={false}
      className={classNames(
        'progress-cards',
        'progress-cards__card',
        'progress-cards__card--withdraw',
      )}
    >
      <Flex vertical>
        <Flex justify={'space-between'}>
          <TextComponent weight={400} level={3}>
            {t('common:profit')}
          </TextComponent>
          <DashboardTooltip tooltipText={tooltipText[application]} />
        </Flex>
        <Flex
          vertical={!isMobile}
          gap={4}
          justify={'space-between'}
          align={isMobile ? 'center' : 'start'}
        >
          <TextComponent level={isMobile ? 3 : 2} weight={600}>
            <Statistic prefix={'$'} value={profit + credits} precision={2} />
          </TextComponent>
        </Flex>
      </Flex>
    </Card>
  );
};
export default ProfitWithdrawal;
